/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Admin_Sync_Status_SubtitleInputs */



/**
* | output |
* | --- |
* | "Last run of the automatic VEKN jobs. Resets when the server restarts." |
*
* @param {Admin_Sync_Status_SubtitleInputs} inputs
* @param {{ locale?: "en" | "fr" | "es" | "pt" | "it" }} options
* @returns {LocalizedString}
*/
export const admin_sync_status_subtitle = /** @type {((inputs?: Admin_Sync_Status_SubtitleInputs, options?: { locale?: "en" | "fr" | "es" | "pt" | "it" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Admin_Sync_Status_SubtitleInputs, { locale?: "en" | "fr" | "es" | "pt" | "it" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Dernier déclenchement des tâches VEKN automatiques. Réinitialise au redémarrage du serveur.")
	if (locale === "es") return /** @type {LocalizedString} */ ("Última ejecución de los trabajos automáticos de VEKN. Se restablece al reiniciar el servidor.")
	if (locale === "pt") return /** @type {LocalizedString} */ ("Última execução dos jobs automáticos do VEKN. Redefine quando o servidor reinicia.")
	if (locale === "it") return /** @type {LocalizedString} */ ("Ultima esecuzione dei job VEKN automatici. Si azzera al riavvio del server.")
	return /** @type {LocalizedString} */ ("Last run of the automatic VEKN jobs. Resets when the server restarts.")
});